import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const links = [
    { to: "/", key: "nav_home", id: "home" },
    { to: "/about", key: "nav_whoiam", id: "who-i-am" },
    { to: "/consultation", key: "nav_consultation", id: "consultation" },
    { to: "/contact", key: "nav_contact", id: "contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const loc = useLocation();
    const { t } = useLang();

    return (
        <header
            data-testid="navbar"
            className="sticky top-0 z-40 backdrop-blur-xl bg-ink-900/75 border-b border-white/5"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-10">
                <Link
                    to="/"
                    data-testid="navbar-logo"
                    className="flex items-baseline gap-2"
                >
                    <span className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
                        Abhijit
                    </span>
                    <span className="font-display text-2xl font-bold gold-text sm:text-3xl">
                        JK
                    </span>
                </Link>

                <nav className="hidden items-center gap-7 lg:flex">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.id}`}
                            className={({ isActive }) =>
                                `text-xs tracking-[0.2em] uppercase font-medium transition-colors ${
                                    isActive
                                        ? "text-gold-300"
                                        : "text-white/70 hover:text-white"
                                }`
                            }
                        >
                            {t(l.key)}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden items-center gap-4 lg:flex">
                    <Link
                        to="/consultation"
                        data-testid="navbar-book-cta"
                        className="gold-button inline-flex items-center"
                    >
                        Book Your Consultation
                    </Link>
                </div>

                <button
                    data-testid="navbar-mobile-toggle"
                    className="lg:hidden text-white p-2"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle navigation"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="navbar-mobile-panel"
                    className="lg:hidden border-t border-white/5 bg-ink-900/95 backdrop-blur-xl"
                >
                    <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-6">
                        {links.map((l) => (
                            <Link
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-${l.id}`}
                                className={`text-sm tracking-[0.2em] uppercase ${
                                    loc.pathname === l.to
                                        ? "text-gold-300"
                                        : "text-white/80"
                                }`}
                            >
                                {t(l.key)}
                            </Link>
                        ))}
                        <Link
                            to="/consultation"
                            onClick={() => setOpen(false)}
                            data-testid="nav-mobile-book-cta"
                            className="gold-button mt-2 inline-flex items-center justify-center"
                        >
                            Book Your Consultation
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
